/*
 * This helpers will prevent from memoization
 * Sometimes selectors or state in reducer can result with empty array or object
 * Instead of creating new empty object or array every time if state is empty
 * we can return already created one
 */
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
